import { useMediaQuery } from 'react-responsive'

import { breakpoints } from '@/const/commonStyles'

const useResponsive = () => {
  const isExtraSmall = useMediaQuery({ query: `(min-width: ${breakpoints.extraSmall}px)` })
  const isSmall = useMediaQuery({ query: `(min-width: ${breakpoints.small}px)` })
  const isMedium = useMediaQuery({ query: `(min-width: ${breakpoints.medium}px)` })
  const isLarge = useMediaQuery({ query: `(min-width: ${breakpoints.large}px)` })
  const isDesktop = useMediaQuery({ query: `(min-width: ${breakpoints.desktop}px)` })
  const isContainer = useMediaQuery({ query: `(min-width: ${breakpoints.container}px)` })

  return {
    isExtraSmall,
    isSmall,
    isMedium,
    isLarge,
    isDesktop,
    isContainer,
  }
}

export default useResponsive
